import { Button } from "@tql/ui-components-react/tql/buttons";
import { mail_01, save_01 } from "@tql/ui-components-react/untitled/icons";

import type { CarrierPrice } from "~/shared/schemas/carrier-schema.ts";
import type { QuoteStateType } from "~/shared/types/quote-details-types.ts";

type RateConfirmationProps = {
	hasCarriers: boolean;
	isAdjustingPrices: boolean;
	isInternal: boolean;
	isSaveQuoteEnabled: boolean;
	isUpdatingMargins: boolean;
	quoteState: QuoteStateType;
	toggleModal: (modal: string) => void;
	updateAllCarrierMargins: (
		quoteId: number,
		eTag: string,
		carriers: CarrierPrice[],
	) => void;
};

export const RateConfirmation = ({
	hasCarriers,
	isAdjustingPrices,
	isInternal,
	isSaveQuoteEnabled,
	isUpdatingMargins,
	quoteState,
	toggleModal,
	updateAllCarrierMargins,
}: Readonly<RateConfirmationProps>) => {
	return (
		<div>
			{isSaveQuoteEnabled ? (
				<Button
					disabled={!hasCarriers || isAdjustingPrices}
					id={"carrier-button"}
					onClick={() => {
						updateAllCarrierMargins(
							quoteState.id,
							quoteState.eTag,
							quoteState.carrierPrices,
						);
					}}
					svgIcon={isUpdatingMargins ? undefined : save_01}
					variant={"tertiary"}
				>
					Save Quote
				</Button>
			) : null}
			{isInternal ? (
				<Button
					disabled={!hasCarriers}
					onClick={() => toggleModal("confirmationRate")}
					svgIcon={mail_01}
					variant={"tertiary"}
				>
					Rate Confirmation
				</Button>
			) : null}
		</div>
	);
};
